// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UnsavedDataModal__wrapper___2so0Q","buttons":"UnsavedDataModal__buttons___2H5ml"};